import { Typography } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledReleaseTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(36),
  fontStyle: 'normal',
  fontWeight: 700,
  lineHeight: '100%',
  letterSpacing: '0.09px',
  marginBottom: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    textAlign: 'center',
    fontSize: theme.typography.pxToRem(24),
    marginBottom: theme.spacing(4),
    minHeight: theme.spacing(12),
  },
}));
